import { Link } from "wouter";
import { ArrowRight } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center relative overflow-hidden">
      <div className="absolute inset-0 gradient-mesh" />
      <div className="absolute top-1/3 left-1/3 w-96 h-96 bg-[#66CDAA]/10 rounded-full blur-[120px]" />
      <div className="container relative z-10 text-center py-20">
        <div className="text-8xl lg:text-9xl font-bold gradient-text font-[Rubik] mb-6">
          404
        </div>
        <h1 className="text-3xl lg:text-4xl font-bold text-white mb-4 font-[Rubik]">
          העמוד לא נמצא
        </h1>
        <p className="text-lg text-white/60 mb-8 max-w-md mx-auto">
          מצטערים, העמוד שחיפשתם לא קיים. אולי הוא הוזז או נמחק.
        </p>
        <Link
          href="/"
          className="glow-btn inline-flex items-center gap-2 text-base px-8 py-4"
        >
          <ArrowRight className="w-5 h-5" />
          חזרה לדף הבית
        </Link>
      </div>
    </div>
  );
}
